import React, { Component } from 'react';
import { FormGroup } from '../forms/FormBootstrap';
import { Field, Formik } from 'formik';
import { string, object } from 'yup';

class CadastroSistema extends Component {
    constructor(props) {
        super(props);
        this.validationSchema = object().shape({
            nomeSistema: string()
                .required("Campo obrigatório")
                .matches(/^([a-z]+[a-z0-9]*){3,25}$/, "Nome inválido")
                .test('ja-existe', 'Este nome já está em uso, escolha outro', async (value) => {
                    var texto = await (await fetch('cadastro/jaexistesistema?nome=' + value)).json();
                    return texto === false;
                }),
        });
    }

    onSubmit(values, actions) {
        if (this.props.onSubmit) {
            this.props.onSubmit(values, actions);
        } else {
            console.log("No onSubmit prop");
        }
    }


    render() {
        return (
            <Formik
                onSubmit={(values, actions) => { this.onSubmit(values, actions) }}
                initialValues={{
                    nomeSistema: this.props.nomeSistema
                }}
                validateOnBlur={false}
                validateOnChange={false}
                validationSchema={this.validationSchema}
                render={(props) => {
                    const {
                        values,
                        touched,
                        errors,
                        handleChange,
                        handleBlur,
                        handleSubmit,
                    } = props;

                    return (
                        <form onSubmit={handleSubmit}>
                            <div className="row">
                                <FormGroup errors={errors} touched={touched} campo="nomeSistema">
                                    <label htmlFor="nomeSistema" id="lbNomeSistema">Nome da conta</label>
                                    <div className="help-block">O nome da conta identifica o seu sistema em nossa nuvem. Use o nome da sua empresa.</div>
                                    <div className="help-block">Este nome só pode conter letras minúsculas, sem pontuação, acentos ou espaços.</div>
                                    <Field className="form-control" id="nomeSistema" name="nomeSistema" aria-describedby="help-nomeSistema" value={values.nomeSistema} onChange={handleChange} onBlur={handleBlur} />
                                </FormGroup>
                            </div>
                            <div className="row">
                                <div className="form-group col-sm-6 col-sm-offset-3">
                                    <button type="submit" className="btn btn-success pull-right">Concluir</button>
                                </div>
                            </div>
                        </form>
                    );
                }
                }
            />
        )
    }

}

export default CadastroSistema;